/**
 * 公共接口管理
 */
import axios from 'axios';
axios.interceptors.request.use(
  config => {
    const AFF_TOKEN = localStorage.getItem('AFF_TOKEN');
    config.headers = {
      ...config.headers,
      'Authorization': 'Bearer ' + AFF_TOKEN
    };
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const baseUrl = window.location.hostname === 'affiliate.gw-ec.com' ? '//affiliate.gw-ec.com/api' : 'http://admin.aff-test.com/api';
// 下载链接，没有api
export const baseDownUrl = window.location.hostname === 'affiliate.gw-ec.com' ? '//affiliate.gw-ec.com' : 'http://admin.aff-test.com';

// 请求 select 选项接口
export function getCommonSelectApi (data) {
  const url = baseUrl + '/publish/select-option';
  return axios.post(url, data);
}

// 登录接口
export function loginApi (data) {
  const url = baseUrl + '/admin/login';
  return axios.post(url, data);
}

// 获取所有语言列表(英文)
export function getEnLanguageApi(data) {
  const url = baseUrl + '/publish/en-language';
  return axios.post(url, data);
}

// 获取联盟客网站类型列表
export function getWebTypeApi(data) {
  const url = baseUrl + '/publish/web-type';
  return axios.post(url, data);
}

// 退出接口
export function logoutApi(data) {
  const url = baseUrl + '/admin/logout';
  return axios.post(url, data);
}

// 获取用户信息
export function queryAdminApi(data) {
  const url = baseUrl + '/admin/index-info';
  return axios.post(url, data);
}

// 切换系统，获取token
export function getMerchantTokenApi(data) {
  const url = baseUrl + '/admin/login-merchant';
  return axios.post(url, data);
}

// 上传图片
export function uploadImgApi(data) {
  const url = baseUrl + '/article/upload';
  return axios.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryrqMNrqj089ePISw6'
    }
  });
}
